import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Drivers from "@/pages/Drivers";
import Vehicles from "@/pages/Vehicles";
import Trips from "@/pages/Trips";
import WeeklyPlanning from "@/pages/WeeklyPlanning";
import WorkTime from "@/pages/WorkTime";
import WorkTimeOverview from "@/pages/WorkTimeOverview";
import Schedule from "@/pages/Schedule";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Docs from "@/pages/Docs";

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard"    element={<Shell><Dashboard /></Shell>} />
            <Route path="/fahrten"      element={<Shell><Trips /></Shell>} />
            <Route path="/wochenplanung" element={<Shell roles={["admin","disponent"]}><WeeklyPlanning /></Shell>} />
            <Route path="/fahrer"       element={<Shell roles={["admin","disponent"]}><Drivers /></Shell>} />
            <Route path="/fahrzeuge"    element={<Shell roles={["admin","disponent"]}><Vehicles /></Shell>} />
            <Route path="/arbeitszeit"  element={<Shell><WorkTime /></Shell>} />
            <Route path="/arbeitszeituebersicht" element={<Shell roles={["admin","disponent"]}><WorkTimeOverview /></Shell>} />
            <Route path="/standardzeiten" element={<Shell roles={["admin","disponent"]}><Schedule /></Shell>} />
            <Route path="/benutzer"     element={<Shell roles={["admin"]}><Users /></Shell>} />
            <Route path="/audit-log"    element={<Shell roles={["admin"]}><AuditLog /></Shell>} />
            <Route path="/docs"         element={<Shell roles={["admin","disponent"]}><Docs /></Shell>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}
